<section class="container-fluid" *ngIf="project">
  <div class="row">
    <div class="col-12">
      <app-project-summary
        [development]="development"
        [project]="project"
        [isMultiDevelopment]="isMultiDevelopment"
        [projectStatus]="projectStatus"
      ></app-project-summary>
    </div>
  </div>
  <div class="card">
    <div class="row">
      <div class="col-lg-4 map-col" *ngIf="!isMultiDevelopment">
        <div class="map">
          <app-arcgis-map
            *ngIf="development?.id"
            [zoom]="mapZoomLevel"
            [showLocationCircle]="false"
            [isProjectPage]="true"
            [inputDevelopmentId]="development.id"
          ></app-arcgis-map>
        </div>
      </div>
      <div [ngClass]="!isMultiDevelopment ? 'col-lg-8' : 'col-lg-12'" style="padding-right: 0px">
        <div class="project-bottom-bg">
          <div class="row">
            <div class="col-lg-3 project-details-max">
              <div class="location first-location">
                <div class="project-bottom-title">Project Location:</div>
                <div *ngIf="isPlannedProject" class="project-bottom-sub-title">
                  <div class="project-bottom-content">
                    {{ toBeDetermined }}
                  </div>
                </div>
                <div *ngIf="!isMultiDevelopment && !isPlannedProject">
                  <div
                    *ngIf="project !== undefined && project.buildings.length"
                    class="project-bottom-sub-title skiptranslate"
                  >
                    <!-- {{ project.buildings.length > 1 ? "Buildings" : "Building" }}<br /> -->
                    <div *ngFor="let b of project.buildings" class="project-bottom-content">
                      {{ b | titleCasewithAvoidWords | simplifyWords }} <br />
                    </div>
                  </div>
                </div>
                <div *ngIf="isMultiDevelopment && !isPlannedProject" class="txt-print-p">
                  <div *ngFor="let dev of filteredMultiDevelopment" class="txt-print skiptranslate">
                    <a
                      [routerLink]="'/developments/' + dev.id"
                      class="project-bottom-content"
                      role="button"
                    >
                      {{ dev.name | titleCasewithAvoidWords }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 project-details-max">
              <div class="location">
                <div class="project-bottom-title">Project Budget:</div>
                <div class="project-bottom-sub-title">Estimated Budget:</div>
                <div class="project-bottom-content">
                  {{ budget > 0 ? (budget | currency : "USD" : "$" : "1.0-0") : toBeDetermined }}
                </div>
                <div class="project-bottom-sub-title">Funding Sources:</div>
                <div class="project-bottom-content">
                  {{
                    (fundingSource.length > 0 ? fundingSource.join(", ") : toBeDetermined)
                      | titleCasewithAvoidWords
                  }}
                </div>
              </div>
            </div>
            <div class="col-lg-3 project-details-max">
              <div class="location">
                <div class="project-bottom-title">Project Staff:</div>
                <div class="project-bottom-sub-title">Project Manager:</div>
                <div
                  class="project-bottom-content"
                  [class.skiptranslate]="
                    project !== undefined &&
                    project.manager !== undefined &&
                    project.manager !== toBeDetermined
                  "
                >
                  {{ project !== undefined && project.manager ? project.manager : toBeDetermined }}
                </div>
                <div class="project-bottom-sub-title">Construction Field Inspector or Manager:</div>
                <div
                  class="project-bottom-content"
                  [class.skiptranslate]="
                    project !== undefined &&
                    project.fieldInspector !== undefined &&
                    project.fieldInspector !== toBeDetermined
                  "
                >
                  {{
                    (project !== undefined && project.fieldInspector
                      ? project.fieldInspector
                      : toBeDetermined
                    ) | titleCasewithAvoidWords
                  }}
                </div>

                <!-- <a
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#contactModal"
                  class="project-bottom-sub-title"
                > -->
                <div style="padding-top: 15px">
                  <a
                    [routerLink]="['/contact/' + (project !== undefined ? project.id : '')]"
                    class="header-a-link"
                    aria-current="page"
                  >
                    Contact NYCHA
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-3 project-details-max">
              <div class="location">
                <div class="project-bottom-title">Project Vendors:</div>
                <div class="project-bottom-sub-title">Architectural/ Engineering:</div>
                <div
                  class="project-bottom-content"
                  [class.skiptranslate]="
                    project !== undefined &&
                    project.projectVendors !== undefined &&
                    project.projectVendors !== toBeDetermined
                  "
                >
                  {{
                    (project !== undefined && project.projectVendors
                      ? project.projectVendors
                      : toBeDetermined
                    ) | titleCasewithAvoidWords
                  }}
                </div>
                <div class="project-bottom-sub-title">General Contractor:</div>
                <div
                  class="project-bottom-content"
                  [class.skiptranslate]="
                    project !== undefined &&
                    project.generalContractor !== undefined &&
                    project.generalContractor !== toBeDetermined
                  "
                >
                  {{
                    (project !== undefined && project.generalContractor
                      ? project.generalContractor
                      : toBeDetermined
                    ) | titleCasewithAvoidWords
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div>
    <button class="btn btn-link printButton" type="button" (click)="printPDF()">
      <i class="icon icon-print icon-white"></i>
      <span class="skiptranslate">PRINT PDF</span>
    </button>
  </div> -->
</section>
<section *ngIf="!project">
  <app-not-exist-data [activityType]="'Project'"></app-not-exist-data>
</section>
<!-- <div
  class="modal fade"
  id="contactModal"
  tabindex="-1"
  aria-labelledby="contactModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-body">
        <app-contact
          [projectId]="project.id"
          [developmentName]="development.name"
          (closeModal)="closeModal()"
        ></app-contact>
      </div>
    </div>
  </div>
</div> -->
